export default __webpack_public_path__ + "static/media/rent-out-space2.2d23185c.png";